import React from 'react';
import Formsy from 'formsy-react';
import FormsyInput from '../../form/FormsyInput';
import FormsySimpleInput from '../../form/FormsySimpleInput';
import withOnboarding from '../withOnboarding';
import Checkbox from '../../form/Checkbox';
import { maskPhone } from '../../../masks';

class ChefDetails extends React.Component {
  state = {
    first_name: '',
    last_name: '',
    email: '',
    phone_number: '',
    password: '',
    password_confirmation: '',
    occasion_opt_in: false
  };

  render() {
    const validationErrors = {
      isEmail: 'Invalid Email',
      equalsField: 'Password must match.'
    };

    return (
      <div className="on-boarding__step on-boarding_step--chef">
        <div className="on-boarding__wrap on-boarding__wrap--chef-details">
          <h1 className="on-boarding__h1">Tell us about yourself.</h1>
          <p className="on-boarding__p">
            Enter your personal details so we can match you with clients.
          </p>

          <Formsy
            onValidSubmit={this.handleSubmit}
            onInvalidSubmit={this.handleInvalidSubmit}
            onValid={this.handleValid}
            onInvalid={this.handleInvalid}
            className="on-boarding__chef-details"
          >
            <p className="p p--bold p--green-text">
              Are you interested in work opportunities outside of your time
              availability?
            </p>
            <div className="form__row">
              <div className="form__row-item form__row-item--half">
                <FormsyInput
                  type="text"
                  name="first_name"
                  placeholder="First Name"
                  value={this.state.first_name}
                  onChange={this.handleChange}
                  required
                />
              </div>
              <div className="form__row-item form__row-item--half">
                <FormsyInput
                  type="text"
                  name="last_name"
                  placeholder="Last Name"
                  value={this.state.last_name}
                  onChange={this.handleChange}
                  required
                />
              </div>
            </div>

            <div className="form__row">
              <div className="form__row-item form__row-item--half">
                <FormsyInput
                  type="text"
                  name="email"
                  placeholder="Email"
                  value={this.state.email}
                  onChange={this.handleChange}
                  validations={'isEmail'}
                  validationErrors={validationErrors}
                  required
                />
              </div>
              <div className="form__row-item form__row-item--half">
                <FormsyInput
                  type="text"
                  name="phone_number"
                  placeholder="Cell Phone Number"
                  value={this.state.phone_number}
                  onChange={this.handleChange}
                  mask={maskPhone}
                  required
                />
              </div>
            </div>

            <div className="form__row form__row--align-top">
              <div className="form__row-item form__row-item--half">
                <FormsyInput
                  type="password"
                  name="password"
                  placeholder="Password"
                  value={this.state.password}
                  onChange={this.handleChange}
                  required
                />
                <p className="p--green-text small">
                  Requires: 1 uppercase, 1 lowercase and 1 number
                </p>
              </div>
              <div className="form__row-item form__row-item--half">
                <FormsyInput
                  type="password"
                  name="password_confirmation"
                  placeholder="Confirm Password"
                  value={this.state.password_confirmation}
                  onChange={this.handleChange}
                  validations={'equalsField:password'}
                  validationErrors={validationErrors}
                  required
                />
              </div>
            </div>

            <div className="form__row">
              <div className="form__row-item p--green-text">
                <p className="p p--bold p--green-text">
                  Are you interested in work opportunities outside of your time
                  availability?
                </p>
                <Checkbox
                  name="occasion_opt_in"
                  placeholder="Yes, I'm Interested."
                  className="checkbox--small checkbox--small-blue"
                  checked={this.state.occasion_opt_in}
                  onChange={this.handleChange}
                />
              </div>
            </div>
            <FormsySimpleInput
              type="hidden"
              name="all_forms_valid"
              value={this.props.actions.isValid('submit')}
              validations="isTrue"
            />
            <input
              ref={this.props.actions.assignTrigger}
              type="submit"
              hidden
            />
          </Formsy>
        </div>
      </div>
    );
  }

  handleChange = ({ target }) => {
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({ [name]: value });
  };

  handleInvalidSubmit = () => console.log('failed submit');

  handleValid = () => this.props.actions.setValidState('main', true);
  handleInvalid = () => this.props.actions.setValidState('main', false);

  // this will be triggered from the ChefOnboarding component
  handleSubmit = (formData, data, errors) => {
    const {
      first_name,
      last_name,
      email,
      phone_number,
      password,
      password_confirmation,
      occasion_opt_in
    } = this.state;
    // update chef
    const updatedChef = {
      first_name,
      last_name,
      email,
      phone_number,
      password,
      password_confirmation,
      occasion_opt_in
    };
    this.props.updateChef(updatedChef, this.props.postSignup);
    // this.props.actions.markComplete(this.props.step);
  };

  deriveState() {
    const {
      first_name = '',
      last_name = '',
      email = '',
      phone_number = '',
      password = '',
      password_confirmation = '',
      occasion_opt_in = false
    } = this.props.chef;

    this.setState({
      first_name,
      last_name,
      email,
      phone_number,
      password,
      password_confirmation,
      occasion_opt_in
    });
  }

  componentDidMount() {
    // handle resets here
    // const reset = this.props.resets.includes(this.props.step);

    this.deriveState();
  }
}

export default withOnboarding(ChefDetails);



// WEBPACK FOOTER //
// ./src/components/onboarding/chef/ChefDetails.js